import React, { useState, useEffect } from 'react'; 
import './TabComponent.css';

const TabComponent = ({ onTabSelect, category }) => {
  const [activeTab, setActiveTab] = useState("overview");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
 

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);

      if (window.innerWidth > 768 && activeTab === 'coursecontent') {
        setActiveTab('overview');
      }
    };

    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, [activeTab]);

  
  // const includesRelevantCategory = [
  //   'development',
  //   'programming',
  //   'SOFTWARE_TESTING',
  //   'SOFTWARE_ENGINEERING',
  //   'SOFTWARE_DEV_TOOLS'
  // ].map(cat => cat.toLowerCase()).includes(category.toLowerCase());
  //     ...(includesRelevantCategory ? [{ id: 'interview', label: 'AI Interview' }] : []),



   const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'coursecontent', label: 'Course Content', mobileOnly: true },
    { id: 'notes', label: 'Notes' },
    { id: 'interview', label: 'AI Interview' } ,
  ];

  const handleTabChange = (id) => {
    setActiveTab(id);
    if (onTabSelect) {
      onTabSelect(id);
    }
  };

  return (
    <div className="course_includes_container">
      <div className="course_includes_tabs">
        {tabs.map((tab) =>
          (!tab.mobileOnly || isMobile) && (
            <button
              key={tab.id}
              className={`course_tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleTabChange(tab.id)}
            >
              {tab.label}
            </button>
          )
        )}
      </div> 
    </div>
  );
};

export default TabComponent;
